module.exports = __webpack_public_path__ + "img/img053.b6add7d6.png";